import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinnerFilledComponent } from '@web/shared/ui';
import { Observable } from 'rxjs';
import { Nillable } from '@web/utils';
import { PublicProductSearchPanelComponent } from '../public-product-search-panel/public-product-search-panel.component';
import { PublicProductSortPanelComponent } from '../public-product-sort-panel/public-product-sort-panel.component';
import { PublicProductSortType } from '../../enums/public-product-sort-type';
import { PublicProductsForSaleTileComponent } from '../public-products-for-sale-tile/public-products-for-sale-tile.component';
import { PublicProductsQuery } from '../../models/public-products-query';
import { PublicProduct } from '../../models/public-product';
import { PublicProductDataSourceService } from '../../services/public-product-data-source.service';

@Component({
  selector: 'app-public-products',
  imports: [
    CommonModule,
    SpinnerFilledComponent,
    PublicProductSearchPanelComponent,
    PublicProductSortPanelComponent,
    PublicProductsForSaleTileComponent,
  ],
  templateUrl: './public-products.component.html',
  styleUrl: './public-products.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicProductsComponent {
  protected products$ = this.productsSource();

  private readonly phrase = signal<Nillable<string>>(null);
  private readonly sortType = signal<Nillable<PublicProductSortType>>(null);
  // prettier-ignore
  private readonly publicProductDataSource = inject(PublicProductDataSourceService);

  public constructor() {
    effect(() => this.reloadProductsWithQuery());
  }

  public handleSortTypeChange(sortType: Nillable<PublicProductSortType>): void {
    this.sortType.set(sortType);
  }

  public handlePhraseChangeEvent(phrase: Nillable<string>): void {
    this.phrase.set(phrase);
  }

  private productsSource(): Observable<PublicProduct[]> {
    return this.publicProductDataSource.fetchProducts();
  }

  private reloadProductsWithQuery(): void {
    this.products$ = this.publicProductDataSource.fetchProducts(
      new PublicProductsQuery({
        sortType: this.sortType(),
        phrase: this.phrase(),
      }),
    );
  }
}
